import React from "react";
import { connect } from "react-redux";
import createDecorator from "final-form-calculate";
import { withRouter } from "react-router-dom";

import { routerPath } from "@config";
import { KYCActions, ToolsActions, ToolsConstants } from "@redux";
import {
  FormFieldType,
  KYCFormSwitch,
  ContentLoader,
  ContentNoData,
} from "@components";
import {
  i18,
  required,
  checkEmail,
  checkMaxLength,
  checkMinLength,
  checkPhonePrefix,
  checkPhoneNumber,
  checkJsonProp,
  checkJsonExist,
  composeValidators,
  getClassificators,
  formatCurrentDate
} from "@utilities";

const classifikatorsMap = obj =>
  obj
    ? Object.entries(obj).map(item => {
        return { label: item[1], value: item[0] };
      })
    : null;

class ApplicationKYCContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.getMarkIdPayload = this.getMarkIdPayload.bind(this);
  }

  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(KYCActions.startKYC());

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  componentWillUnmount = () => {
    const { dispatch } = this.props;

    dispatch(ToolsActions.clearAllPayload());
    dispatch(KYCActions.clearKYCApplication());
  };

  onSubmit = values => {
    const { dispatch, match } = this.props,
      { companyName, kycId } = match.params,
      { path } = match,
      actionType = path === routerPath.newKyc,
      companyNameFromValues = values.companyName;

    if (checkJsonExist(values, "Approve")) delete values.Approve;
    if (checkJsonProp(values, "clientPhone"))
      values.clientPhone.forEach(item => {
        if (checkJsonExist(item, "data.clientPhoneNoPrefix")) delete item.data.clientPhoneNoPrefix;
        if (checkJsonExist(item, "data.clientPhoneNoStr")) delete item.data.clientPhoneNoStr;
      });
    if (checkJsonExist(values, "companyName")) delete values.companyName;

    this.setState({
      data: values
    });

    const data = {
      firstName: checkJsonProp(values, "clientProfile.0.data.clientName"),
      lastName: checkJsonProp(values, "clientProfile.0.data.clientTitle"),
      personalCode: checkJsonProp(values, "clientProfile.0.data.clientId"),
      birthday: checkJsonProp(values, "clientProfile.0.data.clientBirthDate"),
      kycCore: {
        fullClientName: `${checkJsonProp(
          values,
          "clientProfile.0.data.clientName"
        )} ${checkJsonProp(values, "clientProfile.0.data.clientTitle")}`,
        kycFormHeaderId: 180,
        djFormHeaderId: 303,
        riskFormHeaderId: 304,
        profileFormHeaderId: 361,
        data: {
          personData: values
        }
      },
      isDraft: false,
      companyName: companyName ? companyName : companyNameFromValues,
      kycId: kycId
    };
    if (!kycId) delete data.kycId;

    const action = actionType
        ? KYCActions.sendKYCApplication(data)
        : KYCActions.modifyKYCApplication(data),
      success = actionType
        ? KYCActions.POST_SEND_KYC_APPLICATION_SUCCESS
        : KYCActions.POST_MODIFY_KYC_APPLICATION_SUCCESS;

    dispatch(action).then(response => {
      if (response.type === success) this.getMarkIdPayload();
    });
  };

  getMarkIdPayload = () => {
    const { dispatch, applicationKYC } = this.props,
      { data } = this.state,
      newData = {
        name: checkJsonProp(data, "clientProfile.0.data.clientName"),
        surname: checkJsonProp(data, "clientProfile.0.data.clientTitle"),
        personalCode: checkJsonProp(data, "clientProfile.0.data.clientId"),
        birthday: checkJsonProp(data, "clientProfile.0.data.clientBirthDate"),
        automaticConfirmation: true,
        pepCheck: true,
        sanctionCheck: true,
        kycId: checkJsonProp(applicationKYC, "kycId")
      };

    dispatch(ToolsActions.generateMarkIdPayload(newData)).then(response => {
      if (response.type === ToolsConstants.POST_GENERATE_MARK_ID_PAYLOAD_SUCCESS) {
        /*eslint-disable no-undef*/
        MarkidWidget.init(response.payload);
        /*eslint-enable no-undef*/
      }
    });
  };

  clickOndatoStart = () => {
    const { dispatch, applicationKYC } = this.props,
      { data } = this.state,
      newData = {
        name: checkJsonProp(data, "clientProfile.0.data.clientName"),
        surname: checkJsonProp(data, "clientProfile.0.data.clientTitle"),
        personalCode: checkJsonProp(data, "clientProfile.0.data.clientId"),
        birthday: checkJsonProp(data, "clientProfile.0.data.clientBirthDate"),
        email: checkJsonProp(data, "clientMail.0.data.clientEmail"),
        phoneNumber: checkJsonProp(data, "clientPhone.0.data.clientPhoneNo"),
        identificationType: "PHOTO",
        kycId: checkJsonProp(applicationKYC, "kycId")
      };

    dispatch(ToolsActions.startOndatoIdentification(newData)).then(response => {
      if (response.type === ToolsConstants.POST_START_ONDATO_IDENTIFICATION_SUCCESS) {
        window.location = response.payload;
      }
    });
  };

  render() {
    const {
        applicationKYC,
        sendKYC,
        companyNames,
        sendTools,
        match,
        location
      } = this.props,
      { kycId } = match.params,
      companyNameByState = checkJsonProp(location.state, "companyNameByState");

    if (sendKYC || sendTools) return <ContentLoader />;
    if (!applicationKYC) return <ContentNoData />;

    let initialData = kycId
      ? JSON.parse(location.state.initialData).data.personData
      : {
          clientProfile: [
            {
              clientProfileType: "CPROF7",
              data: {}
            }
          ],
          clientAddress: [{}],
          clientPhone: [{}],
          clientMail: [{}],
          clientDocs: [{}],
          clientEmpComp: [{}],
          clientPlanCashTurn: [{}],
          clientPlanTurn: [{}],
          clientIncome: [{}],
          clientFundsRecCountrys: [{}],
          clientFundsSentCountry: [{}]
        };
    if (kycId) {
      const phone = initialData.clientPhone[0].data.clientPhoneNo;
      initialData.clientPhone[0].data.clientPhoneNoPrefix = phone.slice(0, 4);
      initialData.clientPhone[0].data.clientPhoneNoStr = phone.slice(4);
    }

    const classificators = getClassificators(),
      CISO = classifikatorsMap(checkJsonProp(classificators, "CISO")),
      ADRT = classifikatorsMap(checkJsonProp(classificators, "ADRT")),
      DIST = classifikatorsMap(checkJsonProp(classificators, "DIST")),
      PHON = classifikatorsMap(checkJsonProp(classificators, "PHON")),
      MAILL = classifikatorsMap(checkJsonProp(classificators, "MAILL")),
      DOCS = classifikatorsMap(checkJsonProp(classificators, "DOCS")),
      EMPC = classifikatorsMap(checkJsonProp(classificators, "EMPC")),
      PEN = classifikatorsMap(checkJsonProp(classificators, "PEN")),
      PLTUR = classifikatorsMap(checkJsonProp(classificators, "PLTUR")),
      PLCASH = classifikatorsMap(checkJsonProp(classificators, "PLCASH"));

    //const mocData = {"clientProfile":[{"clientProfileType":"CPROF7","data":{"clientName":"Modify","clientTitle":"KYC Test","clientId":"987654321","clientBirthDate":"1990-11-17","clientRegCountry":"AB","clientPoliticsMember":true,"clientTaxPayerConfirm":false}}],"clientAddress":[{"addressType":"ADRT2","data":{"addressCountry":"AB","addressMunicipality":"DIST01","addressCity":"Tsts","addressStreet":"12","addressPostCode":"12312312"}}],"clientPhone":[{"clientPhoneType":"Namu","data":{"clientPhoneNo":"+77777777777", "clientPhoneNoPrefix": "+777", "clientPhoneNoStr": "77777777"}}],"clientMail":[{"clientEmailType":"MAILL1","data":{"clientEmail":"1@1.lt"}}],"clientDocs":[{"clientDocsType":"DOCS1","data":{"clientDocNo":"12341234","clientDocCountry":"AB","clientDocIssuePlace":"12","clientDocIssueDate":"2020-11-17","clientDocValidDate":"2020-11-17"}}],"clientEmpComp":[{"clientEmpCompType":"EMPC1","data":{"clientEmpCompName":"1","clientEmpCompCountry":"AB","clientEmpPosition":"2"}}],"clientPlanCashTurn":[{"data":{"clientPlanCashTurnover":"PLCASH1"}}],"clientPlanTurn":[{"clientPlanTurn":"PEN1","data":{"clientPlanTurnover":"PLTUR1"},"clientPlanCashTurnover":"PEN1"}],"clientIncome":[{"clientIncomeSource":true}],"clientFundsRecCountrys":[{"clientFundsRecCountryType":"PEN1","data":{"clientFundsRecCountry":"AB"}}],"clientFundsSentCountry":[{"clientFundsSentCountryType":"PEN1","data":{"clientFundsSentCountry":"AB"}}]};

    const mapData = [
      {
        title: i18.Labels.ClientProfile, //i18.Labels.ClientOtherAddress
        //messageBefore: i18.NotificationMessages.KYCMainInformacion,
        elements: [
          {
            title: i18.Labels.ClientName,
            name: "clientProfile.0.data.clientName",
            component: FormFieldType.input,
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientTitle,
            name: "clientProfile.0.data.clientTitle",
            component: FormFieldType.input,
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientId,
            name: "clientProfile.0.data.clientId",
            component: FormFieldType.input,
            className: "col-6",
            validate: composeValidators(required, checkMinLength(4), checkMaxLength(35))
          },
          {
            title: i18.Labels.ClientBirthDate,
            name: "clientProfile.0.data.clientBirthDate",
            component: FormFieldType.date,
            className: "col-6",
            validate: required,
            maxDate: formatCurrentDate()
          },
          {
            title: i18.Labels.ClientRegCountry,
            name: "clientProfile.0.data.clientRegCountry",
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            component: FormFieldType.selectSearch,
            className: "col-6",
            validate: required,
            initialValue: "LT"
          }
        ]
      },
      {
        title: i18.Labels.ClientAddress, //i18.Labels.ClientOtherAddress
        //messageBefore: i18.NotificationMessages.KYCContactInformacion,
        canDuplicate: true,
        duplicateName: "clientAddress",
        duplicateDefault: { data: { addressCountry: "LT" } },
        maxRows: ADRT.length - 1,
        elements: [
          {
            title: i18.Labels.AddressType,
            name: "clientAddress.$index.addressType",
            component: FormFieldType.selectSearch,
            options: ADRT,
            optionsLabel: "label",
            optionsValue: "value",
            optionsDisabled: "disabled",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.AddressCountry,
            name: "clientAddress.$index.data.addressCountry",
            component: FormFieldType.selectSearch,
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required,
            initialValue: "LT"
          },
          {
            title: i18.Labels.AddressMunicipality,
            name: "clientAddress.$index.data.addressMunicipality",
            component: FormFieldType.selectSearch,
            options: DIST,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.AddressCity,
            name: "clientAddress.$index.data.addressCity",
            component: FormFieldType.input,
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.AddressStreet,
            name: "clientAddress.$index.data.addressStreet",
            component: FormFieldType.input,
            className: "col-6"
          },
          {
            title: i18.Labels.AddressStreet,
            name: "clientAddress.$index.data.addressStreet",
            component: FormFieldType.input,
            className: "col-6"
          },
          {
            title: i18.Labels.AddressHouse,
            name: "clientAddress.$index.data.addressHouse",
            component: FormFieldType.input,
            className: "col-4 pr-0 pr-md-3"
          },
          {
            title: i18.Labels.AddressFlat,
            name: "clientAddress.$index.data.addressFlat",
            component: FormFieldType.input,
            className: "col-4 px-0 px-md-3"
          },
          {
            title: i18.Labels.AddressPostCode,
            name: "clientAddress.$index.data.addressPostCode",
            component: FormFieldType.input,
            className: "col-4 pl-0 pl-md-3",
            maxLength: 8,
            validate: composeValidators(checkMaxLength(8), required)
          }
        ]
      },
      {
        title: i18.Labels.ClientPhone, // : i18.Labels.OtherClientPhone,
        canDuplicate: true,
        duplicateName: "clientPhone",
        maxRows: PHON.length - 1,
        elements: [
          {
            title: i18.Labels.ClientPhoneType,
            name: "clientPhone.$index.clientPhoneType",
            component: FormFieldType.selectSearch,
            options: PHON,
            optionsLabel: "label",
            optionsValue: "value",
            optionsDisabled: "disabled",
            className: "col-12 col-md-4 offset-md-1",
            classNameTitle: "col-3 text-right",
            classNameField: "col-9 col-md-6",
            classNameError: "col-12 col-md-9 text-right",
            validate: required
          },
          {
            title: i18.Labels.ClientPhoneNo,
            name: "clientPhone.$index.data.clientPhoneNo",
            component: FormFieldType.input,
            className: "col-12 d-none"
          },
          {
            title: i18.Labels.ClientPhoneNo,
            name: "clientPhone.$index.data.clientPhoneNoStr",
            component: FormFieldType.input,
            className: "col-12 col-md-6 text-right p-md-0 addon-unlocked",
            addonBefore: {
              name: "clientPhone.$index.data.clientPhoneNoPrefix",
              className: "col-12 p-0 m-0",
              component: FormFieldType.inputOnly,
              maxLength: 4,
              validate: composeValidators(
                required,
                checkPhonePrefix,
                checkMinLength(4),
                checkMaxLength(4)
              )
            },
            classNameTitle: "col-3 text-right",
            classNameField: "col-9 col-md-6",
            classNameError: "col-7 offset-6 offset-md-5 text-left pl-1",
            maxLength: 8,
            validate: composeValidators(
              required,
              checkPhoneNumber,
              checkMinLength(8),
              checkMaxLength(8)
            )
          }
        ]
      },
      {
        title: i18.Labels.ClientEmail,
        canDuplicate: true,
        duplicateName: "clientMail",
        maxRows: MAILL.length - 1,
        elements: [
          {
            title: i18.Labels.ClientEmailType,
            name: "clientMail.$index.clientEmailType",
            component: FormFieldType.selectSearch,
            optionsLabel: "label",
            optionsValue: "value",
            options: MAILL,
            className: "col-12 col-md-4 offset-md-1",
            classNameTitle: "col-3 text-right",
            classNameField: "col-9 col-md-6",
            classNameError: "col-12 col-md-9 text-right",
            validate: required
          },
          {
            title: i18.Labels.ClientEmail,
            name: "clientMail.$index.data.clientEmail",
            component: FormFieldType.input,
            className: "col-12 col-md-6 text-right p-md-0",
            classNameTitle: "col-3 text-right",
            classNameField: "col-9 col-md-6",
            classNameError: "col-7 offset-6 offset-md-5 text-left pl-1",
            validate: composeValidators(required, checkEmail)
          }
        ]
      },
      {
        //messageBefore: i18.NotificationMessages.KYCPersonDocuments,
        title: i18.Labels.ClientDocuments,
        elements: [
          {
            title: i18.Labels.ClientDocsType,
            name: "clientDocs.0.clientDocsType",
            component: FormFieldType.selectSearch,
            options: DOCS,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6 col-md-4",
            validate: required,
            noInline: true
          },
          {
            title: i18.Labels.ClientDocNo,
            name: "clientDocs.0.data.clientDocNo",
            component: FormFieldType.input,
            className: "col-6 col-md-4",
            maxLength: 8,
            validate: composeValidators(required, checkMinLength(8), checkMaxLength(8)),
            noInline: true
          },
          {
            title: i18.Labels.ClientDocCountry,
            name: "clientDocs.0.data.clientDocCountry",
            component: FormFieldType.selectSearch,
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6 col-md-4",
            validate: required,
            initialValue: "LT",
            noInline: true
          },
          {
            title: i18.Labels.ClientDocIssuePlace,
            name: "clientDocs.0.data.clientDocIssuePlace",
            component: FormFieldType.input,
            className: "col-6 col-md-4",
            validate: required,
            noInline: true
          },
          {
            title: i18.Labels.ClientDocIssueDate,
            name: "clientDocs.0.data.clientDocIssueDate",
            component: FormFieldType.date,
            className: "col-6 col-md-4",
            validate: required,
            maxDate: formatCurrentDate(),
            noInline: true
          },
          {
            title: i18.Labels.ClientDocValidDate,
            name: "clientDocs.0.data.clientDocValidDate",
            component: FormFieldType.date,
            className: "col-6 col-md-4",
            validate: required,
            minDate: formatCurrentDate(),
            noInline: true
          }
        ]
      },
      {
        title: i18.Labels.ClientEmployment,
        canDuplicate: true,
        duplicateName: "clientEmpComp",
        duplicateInside: true,
        maxRows: EMPC.length - 1,
        elements: [
          {
            title: i18.Labels.ClientEmpCompType,
            name: `clientEmpComp.$index.clientEmpCompType`,
            component: FormFieldType.selectSearch,
            options: EMPC,
            optionsLabel: "label",
            optionsValue: "value",
            optionsDisabled: "disabled",
            className: "col-6",
            noInline: true
          },
          {
            title: i18.Labels.ClientEmpCompName,
            name: `clientEmpComp.$index.data.clientEmpCompName`,
            component: FormFieldType.input,
            className: "col-6",
            noInline: true
          },
          {
            title: i18.Labels.ClientEmpCompCountry,
            name: `clientEmpComp.$index.data.clientEmpCompCountry`,
            component: FormFieldType.selectSearch,
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            noInline: true,
            initialValue: "LT"
          },
          {
            title: i18.Labels.ClientEmpPosition,
            name: `clientEmpComp.$index.data.clientEmpPosition`,
            component: FormFieldType.input,
            className: "col-6",
            noInline: true
          }
        ]
      },
      {
        title: i18.Labels.ClientIncomeSource,
        elements: [
          {
            translate: i18.Labels.ClientIncomeSource,
            name: "clientIncome.0.clientIncomeSource",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeSalary,
            name: "clientIncome.0.data.clientIncomeSalary",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeRe,
            name: "clientIncome.0.data.clientIncomeRe",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeIdv,
            name: "clientIncome.0.data.clientIncomeIdv",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeStip,
            name: "clientIncome.0.data.clientIncomeStip",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeStock,
            name: "clientIncome.0.data.clientIncomeStock",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeBenef,
            name: "clientIncome.0.data.clientIncomeBenef",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeSav,
            name: "clientIncome.0.data.clientIncomeSav",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          },
          {
            translate: i18.Labels.ClientIncomeOtherT,
            name: "clientIncome.0.data.clientIncomeOtherT",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title my-1"
          }
        ]
      },
      {
        title: i18.Labels.ClientPlanTurn,
        elements: [
          {
            title: i18.Labels.ClientPlanTurn,
            translate: i18.Labels.ClientPlanTurn,
            name: "clientPlanTurn.0.clientPlanTurn",
            component: FormFieldType.selectSearch,
            options: PEN,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientPlanTurnover,
            name: "clientPlanTurn.0.data.clientPlanTurnover",
            component: FormFieldType.selectSearch,
            options: PLTUR,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          }
        ]
      },
      {
        title: i18.Labels.ClientPlanCashTurn,
        elements: [
          {
            title: i18.Labels.ClientPlanCashTurn,
            translate: i18.Labels.ClientPlanCashTurn,
            name: "clientPlanTurn.0.clientPlanCashTurnover",
            component: FormFieldType.selectSearch,
            options: PEN,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientPlanCashTurnover,
            name: "clientPlanCashTurn.0.data.clientPlanCashTurnover",
            component: FormFieldType.selectSearch,
            options: PLCASH,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          }
        ]
      },
      {
        title: i18.Labels.ClientFundsRec,
        elements: [
          {
            title: i18.Labels.ClientFundsRecCountryType,
            translate: i18.Labels.ClientFundsRecCountryType,
            name: "clientFundsRecCountrys.0.clientFundsRecCountryType",
            component: FormFieldType.selectSearch,
            options: PEN,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientFundsRecCountry,
            name: "clientFundsRecCountrys.0.data.clientFundsRecCountry",
            component: FormFieldType.selectSearch,
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          }
        ]
      },
      {
        title: i18.Labels.ClientFundsSent,
        elements: [
          {
            title: i18.Labels.ClientFundsRecCountryType,
            translate: i18.Labels.ClientFundsRecCountryType,
            name: "clientFundsSentCountry.0.clientFundsSentCountryType",
            component: FormFieldType.selectSearch,
            options: PEN,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          },
          {
            title: i18.Labels.ClientFundsSentCountry,
            name: "clientFundsSentCountry.0.data.clientFundsSentCountry",
            component: FormFieldType.selectSearch,
            options: CISO,
            optionsLabel: "label",
            optionsValue: "value",
            className: "col-6",
            validate: required
          }
        ]
      },
      {
        elements: [
          {
            translate: i18.Labels.ClientPoliticsMember,
            name: "clientProfile.0.data.clientPoliticsMember",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title ml-3 pl-3 ml-md-5 pl-md-4 my-1"
          },
          {
            translate: i18.Labels.ClientTaxPayerConfirm,
            name: "clientProfile.0.data.clientTaxPayerConfirm",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title ml-3 pl-3 ml-md-5 pl-md-4 my-1"
          },
          {
            translate: i18.Labels.ClientBeneficiaryConf,
            name: "clientProfile.0.data.clientBeneficiaryConf",
            component: FormFieldType.checkboxOnly,
            className: "col-12 col-md-4 form-field-title ml-3 pl-3 ml-md-5 pl-md-4 my-1"
          }
        ]
      }
    ];

    if (kycId && companyNames) {
      mapData.unshift({
        title: i18.Labels.CompanyName,
        elements: [
          {
            title: i18.Labels.CompanyName,
            name: "companyName",
            component: FormFieldType.select,
            className: "col-6",
            options: companyNames.map(item => {
              return {
                value: item
              };
            }),
            optionsLabel: "value",
            optionsValue: "value",
            validate: required,
            initialValue: companyNameByState
          }
        ]
      });
    }

    const decorators = createDecorator(
      {
        field: /clientPhone\.*.*clientPhoneNoStr/,
        updates: (value, name, allValues) => {
          if (value !== undefined && value !== null) {
            const toField = name.replace("clientPhoneNoStr", "clientPhoneNo");
            const prefixField = name.replace("clientPhoneNoStr", "clientPhoneNoPrefix");
            const prefixValue = checkJsonProp(allValues, prefixField);
            return {
              [toField]: prefixValue + value
            };
          }
          return {};
        }
      },
      {
        field: /clientPhone\.*.*clientPhoneNoPrefix/,
        updates: (value, name, allValues) => {
          if (value !== undefined && value !== null) {
            const toField = name.replace("clientPhoneNoPrefix", "clientPhoneNo");
            const numberField = name.replace("clientPhoneNoPrefix", "clientPhoneNoStr");
            const numberValue = checkJsonProp(allValues, numberField);
            return {
              [toField]: value + numberValue
            };
          }
          return {};
        }
      }
    );

    return (
      <KYCFormSwitch
        decorators={[decorators]}
        approveSubmitText={i18.NotificationMessages.KYCApproveSubmit}
        mapData={mapData}
        initialData={initialData}
        submit={this.onSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  const { applicationKYC, sendKYC } = state.KYCReducers,
    { companyNames, markIdPayload, sendTools } = state.ToolsReducers;

  return {
    applicationKYC,
    sendKYC,
    companyNames,
    markIdPayload,
    sendTools
  };
}

const connectedApplicationKYCContainer = withRouter(
  connect(mapStateToProps)(ApplicationKYCContainer)
);
export { connectedApplicationKYCContainer as ApplicationKYCContainer };
